<template>
  <div class="container pull-up">
    <div class="row">
      <div class="col-md-12">
        <el-card class="box-card text-center">
          <div slot="header" class="clearfix">
            <h3>{{ $t('ticket.name') }}</h3>
          </div>
          <el-form inline label-position="top" size="mini" :model="query" class="">
            <el-form-item label="Session">
              <el-select clearable collapse-tags v-model="query.session" placeholder="">
                <el-option v-for="(sess, ind) in sessions" :key="sess.id" :value="sess.id"
                           :label="sess.user.name + ' (' + ind + ')'">
                  <span style="float: left">
                     <span :class="sess.status ? 'text-success':'text-danger'">
                      <i class="mdi mdi-circle-small"></i>
                    </span> {{ sess.user.username }}
                  </span>&nbsp;&nbsp;
                  <span style="float: right; color: #8492a6; font-size: 13px">{{
                      sess.created_at | date(true, 'Do/MMM')
                    }} -
                    <span v-if="sess.closed_on">{{ sess.closed_on | date(true, 'Do/MMM') }}</span></span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Start Date">
              <el-date-picker v-model="query.start_date"></el-date-picker>
            </el-form-item>
            <el-form-item label="End Date">
              <el-date-picker v-model="query.end_date"></el-date-picker>
            </el-form-item>
            <el-form-item label="Services">
              <el-select clearable collapse-tags multiple v-model="query.services" placeholder="">
                <el-option v-for="(service, ind) in services" :key="service.id" :label="service.name"
                           :value="service.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Customers">
              <el-select clearable collapse-tags multiple v-model="query.customers" placeholder="">
                <el-option v-for="(cus, ind) in customers" :key="cus.id" :label="cus.name"
                           :value="cus.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Items">
              <el-select clearable collapse-tags multiple v-model="query.items" placeholder="">
                <el-option v-for="(item, ind) in items" :key="item.id" :label="item.name"
                           :value="item.id">
                  <span style="float: left">{{ item.code }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.name }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Categories">
              <el-select clearable collapse-tags multiple v-model="query.categories">
                <el-option v-for="(category, ind) in categories" :key="category.id" :label="category.name"
                           :value="category.id">{{ category.name }}
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="Status">
              <el-select clearable v-model="query.status" placeholder="">
                <el-option label="Pending" value="0"></el-option>
                <el-option label="Completed" value="1"></el-option>
                <el-option label="Revoked" value="-1"></el-option>
              </el-select>
            </el-form-item>

            <!-- <el-form-item label="Has Balance?">
              <el-checkbox v-model="query.has_balance"></el-checkbox>
            </el-form-item> -->

            <el-form-item label="Has Discount?">
              <el-checkbox v-model="query.has_discount"></el-checkbox>
            </el-form-item>

            <el-form-item label="Print?">
              <el-checkbox v-model="query.print"></el-checkbox>
            </el-form-item>

            <el-form-item class="">
              <el-button @click="fetchTickets" :loading="loading" type="primary" click="">Query</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card m-b-30">
          <div class="card-header">
            <el-row type="flex" justify="space-between">
              <el-col :span="20">
                <h5 class="m-b-0">
                  <i class="mdi mdi-ticket"></i> {{ $t('ticket.name') }}
                </h5>
              </el-col>
              <el-col :span="4">
                <el-button v-if="selections.length" @click="printTickets(selections.map(s => s.id))" icon="mdi mdi-printer"
                           type="primary" size="mini">Print Selected ({{ selections.length }})
                </el-button>
              </el-col>
            </el-row>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <el-table @selection-change="setSelection" :data="tickets" style="width: 100%" size="mini" show-summary
                        :summary-method="getSummaries">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="code" label="Ref" width="75px">
                  <template slot-scope="scope">
                    <small>{{ scope.row.code }}</small>
                  </template>
                </el-table-column>
                <el-table-column prop="label" label="Label" width="120px">
                  <template slot-scope="scope">
                    <small>{{ scope.row.label }}</small>
                  </template>
                </el-table-column>
                <el-table-column v-if="query.customers.length" show-overflow-tooltip prop="customer.name"
                                 label="Customer"></el-table-column>
                <el-table-column show-overflow-tooltip label="Store">
                  <template slot-scope="scope">
                    {{ scope.row.session && scope.row.session.store ? scope.row.session.store.name : '' }}
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="items_count" label="#" width="40px">
                  <template slot="header" slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="Article count" placement="top">
                      <span>#</span>
                    </el-tooltip>
                  </template>
                  <template slot-scope="scope">{{ scope.row.items ? scope.row.items.length : 0 }}</template>
                </el-table-column>
                <el-table-column align="left" prop="items" label="Articles" min-width="120px">
                  <template slot-scope="scope">
                    <el-tooltip v-if="scope.row.items && scope.row.items.length" effect="dark" placement="top">
                      <div slot="content">
                        <div v-for="(i, idx) in scope.row.items" :key="idx">
                          <span v-if="i.article">{{ i.article.name }} ({{ i.quantity }})</span>
                        </div>
                      </div>
                      <span style="cursor: pointer; text-decoration: underline;">
                        {{ scope.row.items.length }} item{{ scope.row.items.length > 1 ? 's' : '' }}
                      </span>
                    </el-tooltip>
                    <span v-else>0 items</span>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="owner.name" label="Owner"></el-table-column>
                <el-table-column show-overflow-tooltip prop="service.name" label="Service"></el-table-column>
                <el-table-column prop="amount" align="center" label="Amount">
                  <template slot-scope="scope">{{ scope.row.total_payable | currency(' XAF') }}</template>
                </el-table-column>
                <el-table-column prop="discount" align="center" label="Discount">
                  <template slot-scope="scope">{{ scope.row.total_discount | currency(' XAF') }}</template>
                </el-table-column>
                <el-table-column prop="status" align="center" label="Status" width="80px">
                  <template slot-scope="scope">
                    <el-tag :type="getStatusType(scope.row.status)" size="mini">
                      {{ getStatusText(scope.row.status) }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="Date">
                  <template slot-scope="scope">{{ scope.row.created_at | datetime(true) }}</template>
                </el-table-column>
                <el-table-column :label="$t('label.action')" fixed="right">
                  <template slot-scope="scope">
                    <el-button @click="printTicket(scope.row.id)" size="mini" icon="mdi mdi-printer"/>
                  </template>
                </el-table-column>
              </el-table>
              <div class="text-center pt-3">
                <Pagination
                  :total="total"
                  :current-page="query.page"
                  :page-size="+query.per_page"
                  :page-sizes="[10, 20, 30, 40, 50, 100]"
                  layout="prev, pager, next, sizes"
                  background
                  @current-change="handlePageChange"
                  @size-change="handlePageSizeChange"
                />
                <!--                <span style="float: right;">
                                  <el-button :loading="loading" type="primary" @click="fetchSales(true)" :disabled="!sales.length"
                                             icon="el-icon-printer">{{ $t('button.print') }}
                                  </el-button>
                                </span>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '../_Partials/Pagination.vue'

export default {
  name: 'Index',
  components: { Pagination },
  data () {
    return {
      query: {
        page: 1,
        session: null,
        services: [],
        customers: [],
        items: [],
        categories: [],
        per_page: 10,
        has_balance: false,
        has_discount: false,
        start_date: new Date().toISOString().slice(0, 10),
        end_date: null,
        status: null
      },
      tickets: [],
      total: 0,
      services: [],
      sessions: [],
      items: [],
      categories: [],
      customers: [],
      loading: false,
      selections: []
    }
  },
  methods: {
    handlePageChange (page) {
      this.query.page = page
      this.fetchTickets()
    },
    handlePageSizeChange (size) {
      this.query.per_page = size
      this.query.page = 1
      this.fetchTickets()
    },
    async fetchTickets () {
      try {
        await this.withLoading(async () => {
          const data = await this.$ticketService.getTicketsPaginated(this.query)
          console.log(data)
          this.tickets = data.data || data
          this.total = data.total || (Array.isArray(this.tickets) ? this.tickets.length : 0)
          // Optionally update current page/per_page if backend returns them
          if (data.current_page) this.query.page = data.current_page
          if (data.per_page) this.query.per_page = data.per_page
        }, 'loading')
      } catch (error) {
        // Error is already handled by the global interceptor
        console.log('Component caught error in fetchTickets:', error)
      }
    },
    async fetchSessions () {
      try {
        await this.withLoading(async () => {
          const data = await this.$sessionService.getAllSessions(true)
          this.sessions = data
        }, 'loading')
      } catch (error) {
        // Error is already handled by the global interceptor
        console.log('Component caught error in fetchSessions:', error)
      }
    },
    async fetchCustomers () {
      try {
        await this.withLoading(async () => {
          const data = await this.$customerService.getCustomers()
          this.customers = data
        }, 'loading')
      } catch (error) {
        // Error is already handled by the global interceptor
        console.log('Component caught error in fetchCustomers:', error)
      }
    },
    async fetchServices () {
      try {
        await this.withLoading(async () => {
          const data = await this.$serviceService.getServices()
          this.services = data
        }, 'loading')
      } catch (error) {
        // Error is already handled by the global interceptor
        console.log('Component caught error in fetchServices:', error)
      }
    },
    async fetchItems () {
      try {
        await this.withLoading(async () => {
          const data = await this.$itemService.getItems()
          this.items = data
        }, 'loading')
      } catch (error) {
        // Error is already handled by the global interceptor
        console.log('Component caught error in fetchItems:', error)
      }
    },
    async fetchCategories () {
      try {
        await this.withLoading(async () => {
          const data = await this.$categoryService.getCategories()
          this.categories = data
        }, 'loading')
      } catch (error) {
        // Error is already handled by the global interceptor
        console.log('Component caught error in fetchCategories:', error)
      }
    },
    getSummaries (param) {
      const {
        columns,
        data
      } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = 'Totals'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (!values.every(value => isNaN(value))) {
          sums[index] = this.$currency(values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0))
        } else {
          sums[index] = 'N/A'
        }
      })
      return sums
    },
    async printTicket (ticketIds) {
      if (!Array.isArray(ticketIds)) ticketIds = [ticketIds]
      try {
        await this.withLoading(async () => {
          const data = await this.$ticketService.printTickets(ticketIds)
          // Handle different response formats
          if (data && data.url) {
            this.openUrlInBrowser(data.url)
          } else if (data && typeof data === 'string' && data.includes('http')) {
            this.openUrlInBrowser(data)
          } else {
            // If no URL returned, show success message
            this.notify('Ticket(s) printed successfully', 'Success', 'success')
          }
        }, 'loading')
      } catch (error) {
        // Error is already handled by the global interceptor
        console.log('Component caught error in printTicket:', error)
      }
    },
    async printTickets (ticketIds) {
      await this.printTicket(ticketIds)
    },
    setSelection (selections) {
      this.selections = selections
    },
    getStatusType (status) {
      switch (status) {
        case 0:
          return 'warning'
        case 1:
          return 'success'
        case -1:
          return 'danger'
        default:
          return 'info'
      }
    },
    getStatusText (status) {
      switch (status) {
        case 0:
          return 'Pending'
        case 1:
          return 'Completed'
        case -1:
          return 'Revoked'
        default:
          return 'Unknown'
      }
    }
  },
  async mounted () {
    this.$emit('parent-title', this.$t('ticket.name'))
    try {
      await this.withLoading(async () => {
        await this.fetchServices()
        await this.fetchCustomers()
        await this.fetchSessions()
        await this.fetchItems()
        await this.fetchCategories()
        await this.fetchTickets()
      }, 'loading')
    } catch (error) {
      // Error is already handled by the global interceptor
      console.log('Component caught error in mounted:', error)
    }
  },
  created () {
  }
}
</script>

<style scoped>

</style>
